import { Component, ViewChild } from '@angular/core';
import { Platform, App, NavController, MenuController,IonicApp } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TabsPage } from '../pages/tabs/tabs/tabs';
import { LoginPage } from '../pages/login/login/login';
import { AppState } from './app.global';
import { StorageService } from '../providers/service/storageservice';
import { VersionService } from '../providers/util/versionservice';
import { HttpService } from '../providers/service/httpservice';
import { LOGIN,LOGINWX } from '../providers/config/serviceurl';
//import { WsService } from '../providers/service/websocket';

declare let WeixinJSBridge; // 解决微信返回键

@Component({
  selector:'app-page',
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild('nav')private navCtrl:NavController;

  rootPage:any;
  opid:any;
  currentUser:any;
  wsSubject:any;
  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,public global: AppState,
  private versionService:VersionService,private httpService:HttpService,private _menu: MenuController,
  private _ionicApp: IonicApp, private appCtrl: App) {
  	var colorTheme =  StorageService.getObj('colorTheme');
  	if(colorTheme==null||colorTheme==''||colorTheme.length==0){
  		this.resetColorTheme();
  	}
    platform.ready().then(() => {

      // 监听手机返回键
      this.setupBackButtonBehavior();

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.versionService.checkUpdate(false);//检查更新
      statusBar.styleDefault();
      splashScreen.hide();
      //this.wsSubject = ws.getSubject();//websocket集成  ,public ws:WsService
    });

    this.getOpenid(document.URL);
    console.log("app-opid=" + this.opid);
    StorageService.setObj("opid",this.opid);
    this.currentUser = StorageService.getObj("currentUser");
    //1.如果opid为空的时候，用默认登录，
    //2.如果opid不为空用微信登录
    //2.1 用户不为空，验证用户绑定是否跳转LoginPage
    //2.2 用户为空，验证opid是否绑定，绑定直接跳转TabsPage，未绑定跳转LoginPage
    if(this.opid && this.opid!=null && this.opid!='' && this.opid!='undefined'){
      if(this.currentUser&&this.currentUser.userId!=''&&this.currentUser.userId!=null){
        //用户不为空
        this.getUserByOpidAndUsername(this.opid,this.currentUser.username);
      }else{
        //用户为空
        this.getUserByOpid(this.opid);
      }
    }else{
      //如果opid为空的时候，用默认登录
      if(this.currentUser&&this.currentUser.userId!=''&&this.currentUser.userId!=null){
        this.rootPage=TabsPage;
      }else{
        this.rootPage= LoginPage
      }
    }
  }

  getOpenid(url:any){
    if (url.indexOf("?") > 0) {
		  let splitURL = document.URL.split("?");
		  let splitParams = splitURL[1].split("&");
		  let i: any;
		  for (i in splitParams){
			let singleURLParam = splitParams[i].split('=');
			if (singleURLParam[0] == "opid"){
			  this.opid = singleURLParam[1];
			}
		  }
		}
  }

  getUserByOpid(opid:any){
		if(opid){
			var msgParam = {"opid":opid};
			this.httpService.post2(LOGINWX,msgParam).then(anyObj =>this.handleThings(anyObj));
		}
	}

  getUserByOpidAndUsername(opid:any,username:any){

    var msgParam = {"opid":opid,'username':username};
    this.httpService.post2(LOGINWX,msgParam).then(anyObj =>this.handleThings(anyObj));
  }

  handleThings(obj :any){
		if(obj){
			this.currentUser = obj.currentUser;
			StorageService.setObj("resourceUrl",obj.resourceUrl);
			StorageService.setObj("currentUser",this.currentUser);
		 	StorageService.setObj("oldUserId",this.currentUser.userId);//保存老用户的userId，在重新登录之后判断 是否需要删除个性化设置
		 	if(this.currentUser&&this.currentUser.userId!=null&&this.currentUser.userId!=''){
        // this.navCtrl.setRoot(TabsPage);
        console.log('success');
        this.rootPage = TabsPage;
			}else{
        this.rootPage=LoginPage;
      }
		}else{
      this.rootPage=LoginPage;
    }
	}

  /**重置系统默认主题颜色 */
	resetColorTheme(){
		StorageService.setObj('colorTheme',"color40A0F6");
			this.global.setTheme("color40A0F6");
  }
  
  // 返回按钮事件
  private setupBackButtonBehavior() {
      window.onpopstate = (evt) => {
        if (this._menu.isOpen()) {
            this._menu.close();
            return;
        }
        // 关闭弹出层
        let activePortal = this._ionicApp._loadingPortal.getActive() ||
        this._ionicApp._modalPortal.getActive() ||
        this._ionicApp._toastPortal.getActive() ||
        this._ionicApp._overlayPortal.getActive();

        if (activePortal) {
           activePortal.dismiss();
           return;
        }
        // 当前是否存在 可pop页面
        if (this.navCtrl.canGoBack()) {
           this.appCtrl.goBack();
        } else {
           console.log('不能在返回了!!');
           WeixinJSBridge.call('closeWindow');
        }
      };
      this.appCtrl.viewDidEnter.subscribe((app) => {
        history.pushState(null, null, location.href);
        console.log("1");
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts